const search = h =>
  h(
    'svg',
    {
      width: '12',
      height: '12',
      viewBox: '0 0 12 12',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    [
      h('path', {
        d:
          'M8.576 7.547h-.542l-.192-.185A4.44 4.44 0 0 0 8.92 4.46a4.46 4.46 0 1 0-4.46 4.46 4.44 4.44 0 0 0 2.903-1.078l.185.192v.542L10.977 12 12 10.978l-3.424-3.43zm-4.116 0A3.083 3.083 0 0 1 1.372 4.46 3.083 3.083 0 0 1 4.46 1.372 3.083 3.083 0 0 1 7.547 4.46 3.083 3.083 0 0 1 4.46 7.547z',
        fillRule: 'nonzero',
        stroke: 'none'
      })
    ]
  );

const info = h =>
  h(
    'svg',
    {
      width: '21',
      height: '21',
      viewBox: '0 0 21 21',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    [
      h(
        'g',
        {
          fill: 'none',
          fillRule: 'evenodd'
        },
        [
          h('path', {
            d: 'M1 0h20v20H1z'
          }),
          h(
            'g.icon-svg-info-stroke',
            {
              transform: 'translate(1 .833)',
              stroke: '#FFF',
              strokeLinejoin: 'round'
            },
            [
              h('circle', {
                strokeLinecap: 'round',
                cx: '9.583',
                cy: '9.583',
                r: '9.167'
              }),
              h('path', {
                strokeLinecap: 'round',
                d: 'M7.917 7.917h1.666V15'
              }),
              h('path', {
                d: 'M9.167 4.167a.417.417 0 1 0 0 .833.417.417 0 0 0 0-.833z'
              })
            ]
          )
        ]
      )
    ]
  );

const pageContentTypes = h =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '36',
      height: '30',
      viewBox: '0 0 48 41'
    },
    [
      h('ellipse', {
        cx: '24',
        cy: '15',
        rx: '6',
        ry: '3',
        fill: '#c0f2d6'
      }),
      h('ellipse', {
        cx: '24',
        cy: '4',
        rx: '6',
        ry: '3',
        fill: '#c0f2d6'
      }),
      h('ellipse', {
        cx: '38',
        cy: '10',
        rx: '6',
        ry: '3',
        fill: '#c0f2d6'
      }),
      h('ellipse', {
        cx: '11',
        cy: '10',
        rx: '6',
        ry: '3',
        fill: '#c0f2d6'
      }),
      h('path', {
        d:
          'M17 15c0 2.3 3 4 7 4s7-1.7 7-4-3-4-7-4-7 1.7-7 4zm7-2c3.1 0 5 1.2 5 2s-1.9 2-5 2-5-1.2-5-2 1.9-2 5-2z',
        fill: '#0eb87f'
      }),
      h('path', {
        d:
          'M48 14c0-.1 0-.2-.1-.3v-.1c0-.1-.1-.2-.2-.3l-.1-.1s-.1 0-.1-.1l-3.1-1.3c.4-.5.7-1.1.7-1.8 0-2.3-3-4-7-4-1.8 0-3.4.4-4.7 1l-3-1.3c.4-.5.6-1.1.6-1.7 0-2.3-3-4-7-4s-7 1.7-7 4c0 .6.2 1.2.6 1.7l-2.4 1.1C14 6.3 12.6 6 11 6c-4 0-7 1.7-7 4 0 .5.2 1 .4 1.4L.6 13.1s-.1 0-.1.1c-.1 0-.1.1-.2.1-.1.1-.1.2-.2.3v.1c-.1.1-.1.2-.1.3v16c0 .4.2.7.6.9l22 10c.1 0 .2.1.4.1.1 0 .2 0 .3-.1l24-10c.4-.2.6-.5.6-.9V14h.1zm-5-4c0 .3-.3.7-.9 1.1-.1 0-.2.1-.3.2-.9.4-2.2.7-3.8.7-3.1 0-5-1.2-5-2s1.9-2 5-2 5 1.2 5 2zM24 2c3.1 0 5 1.2 5 2s-1.9 2-5 2-5-1.2-5-2 1.9-2 5-2zm-4.6 5.1c1.2.6 2.8.9 4.6.9 1.8 0 3.4-.3 4.6-.9l3 1.3c-.4.5-.6 1-.6 1.6 0 2.3 3 4 7 4 1.7 0 3.3-.3 4.5-.9l2 .9L23 22.9 3.5 14l2.6-1.1C7.3 13.6 9 14 11 14c4 0 7-1.7 7-4 0-.7-.3-1.4-.8-1.9l2.2-1zM11 8c3.1 0 5 1.2 5 2s-1.9 2-5 2-5-1.2-5-2 1.9-2 5-2zm-9 7.6l20 9.1v13.8L2 29.4V15.6zm44 13.7l-22 9.2V24.7l22-9.2v13.8z',
        fill: '#0eb87f'
      })
    ]
  );

const pageApis = h =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '34',
      height: '33',
      viewBox: '0 0 46 44'
    },
    [
      h('path', {
        d:
          'M36.5 28.8c.1 0 9.5-1.3 9.5-10.6 0-2.9-1.1-5.6-3.2-7.6-1.9-1.9-4.4-2.9-7.1-2.9C33.2 3 28.3 0 23 0 15.8 0 9.7 5.4 8.8 12.5c-2.1-.1-4.1.5-5.7 1.8-1.9 1.6-3 3.9-3 6.3s.7 4.3 2.2 5.7c2.4 2.4 6 2.5 6.5 2.5',
        fill: '#c0f2d6'
      }),
      h('path', {
        d:
          'M42.8 10.6c-1.9-1.9-4.4-2.9-7.1-2.9C33.2 3 28.3 0 23 0 15.8 0 9.7 5.4 8.8 12.5c-2.1-.1-4.1.5-5.7 1.8-1.9 1.6-3 3.9-3 6.3s.7 4.3 2.2 5.7c2.4 2.4 6 2.5 6.5 2.5.6 0 1-.5 1-1s-.5-1-1-1c0 0-3.1 0-5.1-1.9-1-1-1.6-2.5-1.6-4.3 0-1.9.8-3.6 2.3-4.8 1.4-1.2 3.3-1.6 5.2-1.2.3.1.6 0 .8-.2.2-.2.4-.4.4-.7C11 7.1 16.5 2 23 2c4.8 0 9.1 2.8 11.2 7.1.2.4.5.6.9.6 2.3-.1 4.6.8 6.2 2.4 1.7 1.6 2.6 3.8 2.6 6.2 0 7.4-7.4 8.5-7.7 8.6-.5.1-.9.6-.9 1.1.1.5.6.9 1.1.9.1 0 9.5-1.3 9.5-10.6.1-3-1-5.7-3.1-7.7z',
        fill: '#0eb87f'
      }),
      h('path', {
        d:
          'M20.3 36.3L16 40.6V25c0-.6-.4-1-1-1s-1 .4-1 1v15.6l-4.3-4.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l6 6c.1.1.2.2.3.2.1.1.3.1.4.1s.3 0 .4-.1c.1-.1.2-.1.3-.2l6-6c.4-.4.4-1 0-1.4s-1-.4-1.4 0zM35.7 23.3l-6-6c-.1-.1-.2-.2-.3-.2-.2-.1-.5-.1-.8 0-.1.1-.2.1-.3.2l-6 6c-.4.4-.4 1 0 1.4s1 .4 1.4 0l4.3-4.3V38c0 .6.4 1 1 1s1-.4 1-1V20.4l4.3 4.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4z',
        fill: '#0eb87f'
      })
    ]
  );

const pageSettings = h =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '36',
      height: '36',
      viewBox: '0 0 48 48'
    },
    [
      h('path', {
        d:
          'M47 20h-5.7c-.4-1.6-.9-3.3-1.6-4.7l4.1-4.1c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7l-5.7-5.7c-.4-.4-1-.4-1.4 0l-4.1 4.1c-1.3-.6-3.1-1.2-4.7-1.6V1c0-.5-.5-1-1-1h-6c-.5 0-1 .5-1 1v5.7c-1.6.4-3.3.9-4.7 1.6l-4.1-4.1c-.4-.4-1-.4-1.4 0L4.2 9.9c-.2.1-.3.4-.3.7 0 .3.1.5.3.7l4.1 4.1c-.7 1.3-1.2 3.1-1.6 4.7H1c-.5 0-1 .5-1 1v6c0 .5.5 1 1 1h5.7c.4 1.6.9 3.3 1.6 4.7l-4.1 4.1c-.2.2-.3.4-.3.7 0 .3.1.5.3.7L9.9 44c.4.4 1 .4 1.4 0l4.1-4.1c1.3.7 3.1 1.2 4.7 1.6V47c0 .5.5 1 1 1h6c.5 0 1-.5 1-1v-5.7c1.6-.4 3.3-.9 4.7-1.6l4.1 4.1c.4.4 1 .4 1.4 0l5.7-5.7c.4-.4.4-1 0-1.4l-4.1-4.1c.7-1.3 1.2-3.1 1.6-4.7H47c.5 0 1-.5 1-1v-6c0-.4-.5-.9-1-.9zm-1 6h-5.5c-.5 0-.9.3-1 .8-.3 1.1-1 4.1-1.9 5.6-.2.4-.2.9.1 1.2l3.9 3.9-4.2 4.2-3.9-3.9c-.3-.3-.8-.4-1.2-.1-1.5.9-4.4 1.6-5.6 1.9-.4.1-.8.5-.8 1V46h-4v-5.5c0-.5-.3-.9-.8-1-1.1-.3-4.1-1-5.6-1.9-.4-.2-.9-.2-1.2.1l-3.9 3.9-4.2-4.2 3.9-3.9c.3-.3.4-.8.1-1.2-.9-1.5-1.6-4.4-1.9-5.6.1-.4-.3-.7-.8-.7H2v-4h5.5c.5 0 .9-.3 1-.8.3-1.1 1-4.1 1.9-5.6.2-.4.2-.9-.1-1.2l-3.9-3.9 4.2-4.2 3.9 3.9c.3.3.8.4 1.2.1 1.5-.9 4.4-1.6 5.5-1.9.5 0 .8-.4.8-.9V2h4v5.5c0 .5.3.9.8 1 1.1.3 4.1 1 5.5 1.9.4.2.9.2 1.2-.1l3.9-3.9 4.2 4.2-3.9 3.9c-.3.3-.4.8-.1 1.2.9 1.5 1.6 4.4 1.9 5.5.1.5.5.8 1 .8H46v4z',
        fill: '#0eb87f'
      }),
      h('path', {
        d:
          'M39.5 26.8c.1-.4.5-.8 1-.8H46v-4h-5.5c-.5 0-.9-.3-1-.8-.3-1.1-1-4.1-1.9-5.5-.2-.4-.2-.9.1-1.2l3.9-3.9-4.2-4.2-3.9 3.9c-.3.3-.8.4-1.2.1-1.5-.9-4.4-1.6-5.5-1.9-.5-.1-.8-.5-.8-1V2h-4v5.5c0 .5-.3.9-.8 1-1.1.3-4.1 1-5.5 1.9-.4.2-.9.2-1.2-.1l-3.9-3.9-4.2 4.2 3.9 3.9c.3.3.4.8.1 1.2-.9 1.5-1.6 4.4-1.9 5.6-.1.4-.5.7-1 .7H2v4h5.5c.5 0 .9.3 1 .8.3 1.1 1 4.1 1.9 5.6.2.4.2.9-.1 1.2l-3.9 3.9 4.2 4.2 3.9-3.9c.3-.3.8-.4 1.2-.1 1.5.9 4.4 1.6 5.6 1.9.4.1.8.5.8 1V46h4v-5.5c0-.5.3-.9.8-1 1.1-.3 4.1-1 5.6-1.9.4-.2.9-.2 1.2.1l3.9 3.9 4.2-4.2-3.9-3.9c-.3-.3-.4-.8-.1-1.2.7-1.5 1.5-4.4 1.7-5.5zM24 34c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10z',
        fill: '#c0f2d6'
      }),
      h('path', {
        d:
          'M24 14c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z',
        fill: '#0eb87f'
      })
    ]
  );

export default function makeIcons(h) {
  return {
    search: search(h),
    info: info(h),
    pageContentTypes: pageContentTypes(h),
    pageApis: pageApis(h),
    pageSettings: pageSettings(h)
  };
}



// WEBPACK FOOTER //
// ./src/javascripts/utils/legacy-html-hyperscript/icons.es6.js